import React from 'react';
import ReactDOM from 'react-dom';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
} from '@material-ui/core';

function SubmitErrorDialog({users, resolve}) {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      resolve(false);
    }
  };

  const handleCancel = () => resolve(false);
  const handleConfirm = () => resolve(true);

  return (
    <Dialog open onClose={handleClose}>
      <DialogTitle>Os seguintes usuários serão desativados:</DialogTitle>
      <DialogContent dividers>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Nome</strong>
                </TableCell>
                <TableCell>
                  <strong>E-mail</strong>
                </TableCell>
                <TableCell>
                  <strong>Tipo de beneficiado</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user, index) => (
                <TableRow key={index}>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.beneficiary_type}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} variant="contained">
          Cancelar
        </Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default function ShowEmailsDelete(users) {
  return new Promise(resolve => {
    const div = document.createElement('div');
    document.body.appendChild(div);

    const cleanup = () => {
      ReactDOM.unmountComponentAtNode(div);
      div.remove();
    };

    const handleResolve = value => {
      cleanup();
      resolve(value);
    };

    ReactDOM.render(
      <SubmitErrorDialog users={users} resolve={handleResolve} />,
      div,
    );
  });
}
